/*
 * @FilePath: downloadMethods.js
 * @Author: 旭颖
 * @Date: 2023-02-14 16:01:35
 * @LastEditors: 阿小凉
 * @LastEditTime: 2025-09-28 16:41:42
 */
/**
 * 文件下载
 * @param data 请求参数
 * @param  api 接口
 * @param method 请求方法
 * @param fileName 文件名称 默认 'children'
 */
import axios from 'axios'
import { getToken } from '@/libs/token'
const baseURL = '/admin-api'

const extractFileName = (disposition,defaultName = '收益.xlsx') => {
    if (!disposition) return defaultName;

    // 优先匹配 UTF-8 编码的 filename* 字段（你的场景核心）
    // 正则匹配：filename*=utf-8''后接任意字符（非分号结束，避免匹配后续内容）
    const utf8Reg = /filename\*=utf-8''([^;]+)/i;
    const utf8Match = disposition.match(utf8Reg);

    if (utf8Match && utf8Match[1]) {
        // 解码 UTF-8 编码的中文（%E6%8A%80 这类字符转中文）
        return decodeURIComponent(utf8Match[1].trim());
    }

    // 兼容普通 filename 字段（如果后续有非空值场景）
    const normalReg = /filename=([^;]+)/i;
    const normalMatch = disposition.match(normalReg);
    if (normalMatch && normalMatch[1]) {
        // 去除引号、空格，忽略空值
        const fileName = normalMatch[1].replace(/["';\s]/g, '');
        return fileName || defaultName;
    }

    // 兜底默认文件名
    return defaultName;
}

export function fileDownLoad(data, api, method) {
    //文件转化下载方法
    const convertRes2Blob = (response) => {
        const fileName = extractFileName(response.headers['content-disposition'])
        const blob = new Blob([response.data], {
            type: 'application/vnd.ms-excel',
            // type: 'application/pdf',
        })
        const nav = window.navigator
        if (typeof nav.msSaveBlob !== 'undefined') {
            nav.msSaveBlob(blob, decodeURI(fileName))
        } else {
            const blobURL = window.URL.createObjectURL(blob)
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(fileName))
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink) //下载后文件名、
            window.URL
            console.log(tempLink, 'tem')
        }
    }

    const token = getToken()
    let params = {}
    if (method == 'get') {
        params = data
        axios({
            baseURL: baseURL,
            timeout: 60000,
            method: method,
            url: api,
            params,
            headers: {
                Authorization: `${token}`,
                'Content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
            responseType: 'blob',
        })
            .then((response) => {
                const fileName = extractFileName(response.headers['content-disposition'])
                convertRes2Blob(response, fileName)
            })
    } else {
        axios({
            baseURL: baseURL,
            timeout: 60000,
            method: method,
            url: api,
            data,
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-type': 'application/json;charset=UTF-8',
            },
            responseType: 'blob',
        })
            .then((response) => {
                const fileName = extractFileName(response.headers['content-disposition'])
                convertRes2Blob(response, fileName)
            })
    }
}
